import CustomQuill from './CustomQuill';

interface QuillComponentProps {
  text: string;
  initialTextColor?: string;
  updateHandler: (text: string) => void;
}

function QuillComponent({ text, initialTextColor, updateHandler }: QuillComponentProps) {
  return (
    <>
      <CustomQuill
        defaultValue={text}
        onTextChange={updateHandler}
      />
    </>
  );
}

export default QuillComponent;
